import React, {FunctionComponent} from "react";
import {observer} from "mobx-react";
import {IconButton} from "@mui/material";
import {useStorageTranslateContext} from "@app/modules/Translate/contexts/storage";
import {useModelContext} from "@app/contexts/model";
import {useStorageConfirmTranslateContext} from "@app/modules/ConfirmTranslate/contexts/storage";
import {useStorageContext} from "@app/contexts/storage";
import {MAIN_PAGE} from "@app/enums";
import {faLanguage} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


interface IChangeTranslateProps {
}


export const ChangeTranslate: FunctionComponent<IChangeTranslateProps> = observer<FunctionComponent<IChangeTranslateProps>>(function (props) {

    const {translateStore} = useStorageTranslateContext()
    const {languageFileModel} = useModelContext()
    const {globalStorage} = useStorageContext();
    const {confirmTranslateStore} = useStorageConfirmTranslateContext()

    let dataLanguageResponse = languageFileModel.dataLanguage.get()

    let disabled = !dataLanguageResponse

    return <IconButton
        disabled={disabled}
        className="featureButtons__i featureButtons__i--change"
        aria-hidden="true"
        title="Select different languages"
        onClick={() => {
            globalStorage.SelectDiffTranslateIconClicked = true
            if (translateStore.changeSet.size != 0) {
                globalStorage.openModule = MAIN_PAGE.TRANSLATE
                translateStore.handleOpenAlert()
            } else {
                translateStore.clear()
                confirmTranslateStore.clear()
                languageFileModel.dataLanguage.set(null)
            }
        }}
    >
        <FontAwesomeIcon icon={faLanguage}/>
    </IconButton>
});

